import router from '../../shared/router';
import MenuService from '../../core/components/sidebar/MenuService';
import MenuItem from '../../core/components/sidebar/MenuItem';
import FileManipulationControllerView from './FileManipulationControllerView';
import StorageListView from './StorageList/StorageListView';
import BatchListView from './BatchList/BatchListView';
import BatchEndpointView from './BatchEndpoint/BatchEndpointView';

const {routes} = router.options;
const route = routes.find(r => r.name === 'app');

const tmpRoutes = [
  {
    path: '/file-manipulation', component: FileManipulationControllerView,
    children: [
      {
        path: 'storage-list',
        component: StorageListView,
      },
      {
        path: 'batch-file',
        component: BatchListView,
      },
      {
        path: 'batch-endpoint',
        component: BatchEndpointView,
      },
    ],
  },

];

tmpRoutes.forEach((obj) => {
  route.children.push(obj);
});

router.addRoutes([route]);
// MenuService.addItem(new MenuItem('File Manipulation Controller', {
//   text: 'File Manipulation Controller',
//   weight: 100,
//   uuid: 'File Manipulation Controller',
//   permission: 'read',
//   icon: ['fas', 'file'],
//   children: [
//     {
//       path: '/file-manipulation-controller/storage-list',
//       text: 'FTP Storage List',
//       weight: 1,
//       icon: ['fas', 'cloud']
//     },
//     {
//       path: '/file-manipulation-controller/batch-file',
//       text: 'Batch File',
//       weight: 1,
//       icon: ['fas', 'clipboard-list']
//     },
//     {
//       path: '/file-manipulation-controller/batch-endpoint',
//       text: 'Batch Endpoint',
//       weight: 1,
//       icon: ['fas', 'code-branch']
//     }
//   ]
// }));
